/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import { IModel } from './interface/IModel';

/**
 * 一个空的EmptyModel，用来占位
 */
export default class EmptyModel implements IModel {
    public initModel(props: any) {
        // do nothing
    }
}
